module.exports = __webpack_public_path__ + "static/media/ensalada_crujiente.7f851e5c.png";